"use client";

import { http, createConfig } from "wagmi";
import { defineChain } from "viem";
import { injected, walletConnect } from "wagmi/connectors";

// Hardhat local chain
export const hardhatLocal = defineChain({
  id: 31337,
  name: "Hardhat Local",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: { http: ["http://127.0.0.1:8545"] },
  },
});

// Avalanche Fuji Testnet
export const avalancheFuji = defineChain({
  id: 43113,
  name: "Avalanche Fuji",
  nativeCurrency: { name: "AVAX", symbol: "AVAX", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://api.avax-test.network/ext/bc/C/rpc"] },
  },
  blockExplorers: {
    default: { name: "Snowtrace", url: "https://testnet.snowtrace.io" },
  },
  testnet: true,
});

// Contract addresses (local deployment)
export const CONTRACT_ADDRESSES = {
  Treasury: "0x5FbDB2315678afecb367f032d93F642f64180aa3",
  AelionToken: "0xe7f1725E7734CE288F8367e1Bb143E90bb3F0512",
  LVSONFT: "0x9fE46736679d2D9a65F0992F2272dE9f3c7fa6e0",
  StarterMinter: "0xCf7Ed3AccA5a467e9e704C703E8D87F634fB0Fc9",
  Marketplace: "0xDc64a140Aa3E981100a9becA4E685f962f0cF6C9",
  Breeding: "0x5FC8d32690cc91D4c39d9d3abcBD16989F875707",
  DungeonRewards: "0x0165878A594ca255338adfa4d48449f69242Eb8F",
} as const;

export const wagmiConfig = createConfig({
  chains: [hardhatLocal, avalancheFuji],
  connectors: [
    injected(), // MetaMask, Core Wallet
    ...(process.env.NEXT_PUBLIC_WC_PROJECT_ID
      ? [walletConnect({ projectId: process.env.NEXT_PUBLIC_WC_PROJECT_ID })]
      : []),
  ],
  transports: {
    [hardhatLocal.id]: http(),
    [avalancheFuji.id]: http(),
  },
  ssr: true,
});
